import type { CountryLocation, LocationsPayload } from "../types/domain";

let cache: CountryLocation[] | null = null;

export async function loadLocations(): Promise<CountryLocation[]> {
  if (cache) return cache;
  const response = await fetch("/assets/locations-cis.json");
  if (!response.ok) throw new Error("Не удалось загрузить список городов.");
  const payload = (await response.json()) as LocationsPayload;
  cache = Array.isArray(payload.countries) ? payload.countries : [];
  return cache;
}

export function findCountry(countries: CountryLocation[], code: string): CountryLocation | null {
  return countries.find((country) => country.code === code) ?? null;
}
